module.exports = "<iframe [src]=\"url\" class=\"asp-iframe\"></iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pregled-verifikacije/pregled-verifikacije.component.html
// module id = ./src/app/pages/pregled-verifikacije/pregled-verifikacije.component.html
// module chunks = main